import React, { useState } from 'react'
import { InputGroup, Input } from 'rsuite'
import Icon from './Icon'

// redux
import { useSelector, useDispatch } from 'react-redux'
import { getFavourites } from '../redux/options/selectors'
import { setFavourites } from '../redux/options/actions'

// tools
import { toCarNumber, addFavourite, removeFavourite, FAVOURITES_LABEL } from '../tools/Favourites'

/**
 * Add and remove favourite cars; they get a star in the lists and form their own group
 * @returns {JSX.Element} favourites form
 */
const FavouritesForm = () =>
{
  // state
  const favourites = useSelector( getFavourites )
  const [ value, setValue ] = useState( '' )
  const dispatch = useDispatch()

  /**
   * Add the typed car to the favourites
   * @returns {void}
   */
  const onAdd = () =>
  {
    dispatch( setFavourites( addFavourite( favourites, value ) ) )
    setValue( '' )
  }

  /**
   * Remove a car from the favourites
   * @param {number} car start number
   * @returns {void}
   */
  const onRemove = ( car ) => dispatch( setFavourites( removeFavourite( favourites, car ) ) )

  /**
   * Add on the enter key
   * @param {KeyboardEvent} e key event
   * @returns {void}
   */
  const onKey = ( e ) =>
  {
    if ( e.key === 'Enter' ) onAdd()
  }

  return (
    <React.Fragment>
      <InputGroup>
        <Input placeholder="Add a registration number" onChange={ input => setValue( toCarNumber( input ) ) } value={ value } onKeyDown={ onKey }></Input>
        <InputGroup.Button onClick={ onAdd }>
          <Icon icon="star"/> Add
        </InputGroup.Button>
      </InputGroup>
      { favourites.length > 0 &&
        <ul className="favourites-list">
          { favourites.map( car => (
            <li key={ car }>
              <Icon icon="star" className="favourite"/> { car }
              <button
                type="button"
                className="favourite-remove"
                onClick={ () => onRemove( car ) }
                title={ `Remove ${ car } from favourites` }
                aria-label={ `Remove ${ car } from favourites` }
              ><Icon icon="cross"/></button>
            </li>
          ) ) }
        </ul>
      }
      <p className="help">Favourite cars get a star in the lists, and form the group { FAVOURITES_LABEL } at the bottom of the group lists.</p>
    </React.Fragment>
  )
}

export default FavouritesForm
